import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserCreateEdit } from 'src/app/models/user.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { UserService } from 'src/app/services/http/user.service';
import { RoleService } from 'src/app/services/http/role.service';
import { RegionService } from 'src/app/services/http/region.service';
import { DistrictService } from 'src/app/services/http/district.service';
import { TranslationService } from 'src/app/services/http/translation.service';
import { AuthService, SystemSourceEnum } from 'src/app/services/http/auth.service';
import { IAppliedFilter } from 'src/app/interface/applied-filter';
import { IFilterResponse } from 'src/app/interface/filter-response';
import { IOption } from 'src/app/interface/option';
import { SystemComponentEnum } from 'src/app/models/enums/systemComponent.enum';
import { PrimaryDialogComponent } from '../primary-dialog/primary-dialog.component';
import { UserCreateEditComponent } from './user-create-edit/user-create-edit.component';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';

export interface UserElement {
  id: number;
  dateCreated: Date;
  name: string;
  role: string;
  email: string;
  phoneNumber: string;
  status: string;
}

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent {
  @ViewChild(UserCreateEditComponent) popupComponentRef!: UserCreateEditComponent;
  @ViewChild(ModalConfirmComponent) confirmModal!: ModalConfirmComponent;

  appliedFilters: IAppliedFilter[] = []
  searchInput: string = '';
  public currentPage: number = 1;
  public pageSize: number = 10;
  public count: number = 0;
  public showDeleteModal: boolean = false;
  public showChangeStatusModal: boolean = false;
  public isDisalbed = false;

  public selectedUser: any = {
    id: "",
    name: '',
    applications: [],
    role: 0,
    email: '',
  };;
  public users: any[] = []

  ngOnInit(): void {
    this.reloadTable();
  }

  constructor(private userService: UserService,
    private toastr: ToastrService) { }

  handleChangeFilter(appliedFilters: IFilterResponse) {
    this.appliedFilters = appliedFilters.filters;
    this.searchInput = appliedFilters.searchFilter;
    this.currentPage = 1;
    this.reloadTable()
  }

  pageChange(value: number) {
    this.currentPage = value
    this.reloadTable()
  }

  resetSelectedBU() {
    this.selectedUser = {
      id: "",
      name: '',
      applications: [],
      role: 0,
      email: '',
    };
  }

  reloadTable(page: any = null) {
    if (page)
      this.currentPage = page;

    this.resetSelectedBU();

    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      search: this.searchInput
    };

    this.userService.getAll(obj).subscribe(response => {
      console.log(response)
      this.users = response.data.data;
      this.count = response.data.count;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  selectUser(id?: any) {
    if (id != null) {
      let tempUser = this.users.find(x => x.id === id);
      this.openTab(tempUser);
    }
    else
      this.openTab();

  }
  resetPassword(email?: any) {
    this.userService.resetPassword(email).subscribe(response => {
      this.toastr.success(response.message)
      this.reloadTable()
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  openTab(data?: any) {
    if (data) {
      this.popupComponentRef.changeState(1, data);
    }
    else {
      this.popupComponentRef.changeState(1);
    }
  }

  openTabDelete(id: any) {
    this.showDeleteModal = true;
    this.selectedUser = this.users.find(x => x.id === id);
    this.confirmModal.changeState();
  }

  openTabChangeStatus(user: any, status: boolean) {
    this.showChangeStatusModal = true;
    this.selectedUser = user;
    this.isDisalbed = status;
    this.confirmModal.changeState();
  }
  
  delete() {
    this.userService.delete(this.selectedUser.id).subscribe(response => {
      this.toastr.success(response.message)
      this.reloadTable()
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  cancelDelete() {
    this.showDeleteModal = false;
  }

  cancelChangeStatus(){
    this.showChangeStatusModal = false;
  }

  changeUserStatus() {
    let obj = {
      email: this.selectedUser.email,
      isDisabled: this.isDisalbed
    }

    this.userService.changeUserStatus(obj).subscribe(response => {
      this.toastr.success(response.message)
      this.reloadTable()
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }
}
